import {loadLib} from "../utils/loadLib";

let bootstrapCollapsePromise;

async function onReady() {
	const elements = [...document.querySelectorAll('[data-vg-map]')];
	const mapStores = document.getElementById('yaMapStores');

	if (elements.length || mapStores) {
		const [VGMap, YandexMapLoader] = await Promise.all([
			loadLib.vgMap(),
			loadLib.yandexMap()
		]);

		elements.forEach(map => {
			new YandexMapLoader().loadIfVisible(map, function () {
				VGMap.init(map);
			});
		});

		if (mapStores) {
			new YandexMapLoader().loadIfVisible(mapStores, function (){
				VGMap.init('yaMapStores', {
					callback: {
						afterInitMap: function (map, params, _this) {
							VGMapCustom.run(map, params, _this);
						}
					}
				});
			});
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);
document.addEventListener("turbo:render", (event) => {
	if (event.target?.hasAttribute('data-turbo-preview') === true) return;
	onReady();
});

const VGMapCustom = {
	run: function (map, params, self) {
		// Карта инициализирована, все параметры получены. Дальше ебитесь сами!
		params.marker.color = 'red'
		let points = self.PlaceMark.set(map, params),
			$pointList = document.querySelectorAll('[data-map-toggle="address"]');

		let stores = document.querySelector('.stores');

		points.forEach(function (placemark, i) {
			placemark.events.add('click', function (e) {
				let target = e.get('target'),
					coordinates = target.geometry._coordinates;

				[...points].map((placemark) => {
					placemark.options.set('iconImageHref', '/assets/_frontend/images/icons/marker.svg');
				})

				placemark.options.set('iconImageHref', '/assets/_frontend/images/icons/marker-black.svg');

				map.setCenter(coordinates, 17);

				if ($pointList.length) {
					$pointList.forEach(function (point, n) {
						if (i === n) {
							const address = point.closest('.address');
							const collapse = point.closest('.accordion-item')?.querySelector('.collapse');

							activateAddress(stores, address, collapse);
						}
					});
				}
			});
		});

		if ($pointList.length) {
			$pointList.forEach(function (point, i) {
				point.onclick = function () {
					const address = this.closest('.address');
					const collapse = this.closest('.accordion-item')?.querySelector('.collapse');

					activateAddress(stores, address, collapse);

					let coordinates = this.dataset.coord;
					if(coordinates) {
						coordinates = coordinates.split(',');
						map.setCenter(coordinates, 17);
						self.Map.offset(map, params);

						points.forEach(function (placemark, n) {
							if (i === n) {
								[...points].map((point) => {
									point.options.set('iconImageHref', '/assets/_frontend/images/icons/marker.svg');
								})

								placemark.options.set('iconImageHref', '/assets/_frontend/images/icons/marker-black.svg');
							}
						});
					}

					return false;
				};
			});
		}

		const cities = document.querySelectorAll('[data-map-toggle="city"]');
		[...cities].map((city) => {
			city.onclick = function () {
				let coordinates = city.dataset.coordinates;

				if(coordinates) {
					coordinates = coordinates.split(',');
					map.setCenter(coordinates, 9);
					self.Map.offset(map, params);
				}

				return false;
			};
		});
	},
}

function getBootstrapCollapse() {
	if (!bootstrapCollapsePromise) {
		bootstrapCollapsePromise = loadLib.bootstrapCollapse();
	}

	return bootstrapCollapsePromise;
}

function getCollapseInstance(BootstrapCollapse, collapse) {
	if (typeof BootstrapCollapse.getOrCreateInstance === 'function') {
		return BootstrapCollapse.getOrCreateInstance(collapse, {
			toggle: false
		});
	}

	if (typeof BootstrapCollapse.getInstance === 'function') {
		return BootstrapCollapse.getInstance(collapse) || new BootstrapCollapse(collapse, {
			toggle: false
		});
	}

	return new BootstrapCollapse(collapse, {
		toggle: false
	});
}

function clearSelectedAddresses(stores) {
	[...stores.querySelectorAll('.address.show')].forEach((address) => {
		address.classList.remove('show');
	});
}

function closeOtherCollapses(stores, activeCollapse) {
	const collapses = [...stores.querySelectorAll('.addresses.show')].filter((collapse) => collapse !== activeCollapse);

	if (!collapses.length) {
		return;
	}

	getBootstrapCollapse().then((BootstrapCollapse) => {
		collapses.forEach((collapse) => {
			const instance = getCollapseInstance(BootstrapCollapse, collapse);
			instance.hide();
		});
	});
}

function activateAddress(stores, address, collapse) {
	if (!stores || !address) {
		return;
	}

	clearSelectedAddresses(stores);
	closeOtherCollapses(stores, collapse);

	const scrollToAddress = () => {
		address.classList.add('show');
		scrollParentToChild(stores, address);
	};

	if (!collapse) {
		requestAnimationFrame(scrollToAddress);
		return;
	}

	if (collapse.classList.contains('show')) {
		requestAnimationFrame(scrollToAddress);
		return;
	}

	collapse.addEventListener('shown.bs.collapse', scrollToAddress, {
		once: true
	});

	getBootstrapCollapse().then((BootstrapCollapse) => {
		const instance = getCollapseInstance(BootstrapCollapse, collapse);
		instance.show();
	});
}

function scrollParentToChild(parent, child) {
	const parentRect = parent.getBoundingClientRect();
	const childRect = child.getBoundingClientRect();
	const currentScrollTop = parent.scrollTop;
	const childTop = childRect.top - parentRect.top + currentScrollTop;
	const childBottom = childTop + childRect.height;
	const viewTop = currentScrollTop;
	const viewBottom = viewTop + parent.clientHeight;
	const padding = 16;

	if (childTop < viewTop + padding) {
		parent.scrollTo({
			top: Math.max(0, childTop - padding),
			behavior: 'smooth'
		});
		return;
	}

	if (childBottom > viewBottom - padding) {
		parent.scrollTo({
			top: Math.max(0, childBottom - parent.clientHeight + padding),
			behavior: 'smooth'
		});
		return;
	}

	parent.scrollTo({
		top: Math.max(0, childTop - Math.max(0, (parent.clientHeight - childRect.height) / 2)),
		behavior: 'smooth'
	});
}
